import { gql } from 'graphql-request';

export default gql`
  query Conferences(
    $skip: Int
    $take: Int
    $orderBy: JSON
    $filters: JSON
    $mask: String
  ) {
    conferences(
      skip: $skip
      take: $take
      orderBy: $orderBy
      filters: $filters
      mask: $mask
    ) {
      totalCount
      skip
      take
      conferences {
        id
        account_id
        doc
        listing
        createdAt
        updatedAt

        Owner {
          id
          doc
        }
      }
    }
  }
`;
